import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { BorderRadius, Colors, Fonts, Spacing } from "@snapchat/snap-design-system";

export const VisibilityOptionsWrapper = styled.div`
    padding: ${Spacing.XL}px 0;
`;

export const VisibilityHeading = styled.h3`
    ${Fonts.Heading.H500}
    margin-bottom: ${Spacing.SM}px;
`;

export const visibilityOptionWithBorder = css`
    height: unset;
    min-height: 56px;
    border: 1px solid ${Colors.Gray.V300};
    border-radius: ${BorderRadius.container}px;

    &:not(:last-child) {
        margin-bottom: ${Spacing.SM}px;
    }
`;

export const alertWithBackground = css`
    background-color: #fff0dd;
`;

export const LensNameHeading = styled.h4`
    padding-top: ${Spacing.SM}px;
    ${Fonts.Heading.H500};
`;

export const VisibilitySectionWrapper = styled.div`
    width: ${(100 / 3) * 2}%;
`;

export const spectaclesVisibilityNotice = css`
    margin-bottom: ${Spacing.XS}px;
`;
